import { ButtonWithDropdown, Icon, iconSizes, useOnOutsideClick } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import useVariants from "Catalog/shared/hooks/useVariants"

import Dropdown from "./Dropdown"
import { StyledVariant, Label, StyledButtonContent } from "./Styles"

const VariantSelector = (): JSX.Element => {
  const { t } = useTranslation()
  const { selectedVariant } = useVariants()

  const [isOpen, setOpen] = React.useState(false)
  useOnOutsideClick([], isOpen, () => setOpen(false))

  return (
    <>
      <StyledVariant>
        <Label>{t("variants.select.label")}</Label>

        <ButtonWithDropdown
          buttonContent={
            <StyledButtonContent>
              {selectedVariant !== null ? (
                <>
                  <Icon code="layers" size={iconSizes._20} />
                  {selectedVariant.name}
                </>
              ) : (
                t("variants.select.default")
              )}
            </StyledButtonContent>
          }
          renderDropdown={({ close }) => <Dropdown onClose={close} />}
          variant="emptyOverGray"
          reducedHeight={true} // To fit within the toolbar's height
        />
      </StyledVariant>
    </>
  )
}

export default VariantSelector
